/* eslint-disable react/prop-types */
import React from 'react';
import _ from 'lodash';
import { LikeOutlined } from '@ant-design/icons';
export var renderTitle = title => /*#__PURE__*/React.createElement("span", null, title);
export var renderItem = (scenario, title, count) => ({
  value: JSON.stringify(scenario),
  label: /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      paddingRight: 2
    }
  }, title), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(LikeOutlined, null), " ", count))
});
export function scenarioToFormValues(scenario) {
  var {
    parameters
  } = scenario;
  return _.reduce(parameters, function (result, param) {
    var {
      scenarioParam,
      value
    } = param;
    result.code[scenarioParam] = value;
    result.formValues[scenarioParam] = {
      checked: true,
      value
    };
    return result;
  }, {
    code: {},
    formValues: {}
  });
}
export function formToScenarioParams(formValues) {
  return _.reduce(formValues, function (result, value, key) {
    if (value.checked) {
      var obj = {
        scenarioParam: key,
        value: value.value
      };
      result.push(obj);
    }

    return result;
  }, []);
}
export function formToCodeValues(formValues) {
  var code = _.reduce(formValues, function (result, value, key) {
    if (value.checked) {
      result[key] = value.value;
    }

    return result;
  }, {});

  return code;
}
export function formToFormValues(formValues) {
  var code = formToCodeValues(formValues);
  return {
    code,
    formValues
  };
}
export function extractKeywords(scenarios) {
  var tags = [];

  _.reduce(scenarios, (result, scenario, index) => {
    var {
      keywords
    } = scenario;
    console.log('Running on: ', keywords);
    keywords.split.forEach(keyword => tags.push(keyword));
    return result;
  });

  console.log(tags);
  return [...new Set(tags)];
}